// 只检查当前项目的声明式跳转，不执行旧脚本，也不改写任何页面。
export function pageDeletionState (project, pageId, options = {}) {
  const pages = project.pages || []
  const page = pages.find(item => item.id === pageId)
  const remainingPages = pages.filter(item => item.id !== pageId)
  const references = []
  const isHome = project.homePageId === pageId
  remainingPages.forEach(source => {
    // 当前编辑页的 nav 可能刚被替换，尚未同步回 page.nodes。
    const nodes = source.id === options.activePageId && Array.isArray(options.nodes) ? options.nodes : source.nodes
    const walk = (items, parent = []) => (items || []).forEach((node, index) => {
      const componentPath = parent.concat(index)
      const action = node.navigation
      const add = label => references.push({
        pageId: source.id, pageName: source.name, componentId: node.index, componentPath,
        componentName: node.name || node.title || (node.component || {}).prop || '未命名组件', label
      })
      if (action && action.type === 'page' && action.pageId === pageId) add('页面跳转')
      if (action && action.type === 'pages' && action.source === 'custom' && Array.isArray(action.items)) action.items.forEach((item, i) => {
        if (item && item.pageId === pageId) add('导航项 ' + (i + 1))
      })
      if (action && action.type === 'product') {
        if (Array.isArray(action.routes)) action.routes.forEach((route, i) => {
          if (route && route.pageId === pageId) add('产品规则 ' + (i + 1))
        })
        if (action.fallback && action.fallback.type === 'page' && action.fallback.pageId === pageId) add('未配置产品的默认跳转')
      }
      if (Array.isArray(node.children)) walk(node.children, componentPath)
    })
    walk(nodes)
  })
  let error = ''
  if (!page) error = '页面已不存在，请关闭后重试。'
  else if (!remainingPages.length) error = '项目至少需要保留一个页面。'
  else if (references.length) error = '其他页面仍有跳转指向此页，请先修改以下组件的交互设置。'
  else if (isHome && !remainingPages.some(item => item.id === options.replacementHomeId)) error = '请选择删除后使用的首页。'
  return { page, remainingPages, references, isHome, error }
}
